import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=35c87922&scoped=true&"
import script from "./loading.vue?vue&type=script&lang=js&"
export * from "./loading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c87922",
  null
  
)

component.options.__file = "loading.vue"
export default component.exports